import { get, post } from "../Config";

export function GetPointHistory({ params }) {
  return get({ url: `/api/impact/v1/customer/pointHistory`, params });
}
